<template>
  <b-form @submit.prevent="saveLiquidation" ref="form" autocomplete="off">
    <b-row class="mb-3">
      <b-col lg="12" md="12" sm="12">
        <div class="label_input text_red">* Campos requeridos.</div>
      </b-col>
      <b-col lg="12" md="12" sm="12" class="mb-3">
        <div role="group">
          <label class="label_input">Tipos de Gastos<span class="text_red">*</span></label>
          <v-select
            :options="variables"
            multiple
            label="name"
            class="style-chooser style-chooser-multiple"
            placeholder="Seleccione"
            v-model="formData.variables_costs"
            :disabled="isDisabled"
            @input="calculateTotal"
          >
            <div slot="no-options">Sin opciones</div>
          </v-select>
        </div>
      </b-col>
    </b-row>
    <b-row class="mb-4" v-if="formData.variables_costs.length > 0">
      <b-col lg="12" md="12" sm="12" class="mb-2">
        <div class="text-liquidation">Gastos</div>
      </b-col>
      <b-col lg="12" md="12" sm="12" class="mb-2">
        <b-row v-for="item in formData.variables_costs" :key="item.uuid">
          <b-col lg="6" md="6" sm="12" class="mb-3">
            <div role="group">
              <label :for="item.uuid" class="label_input">{{ item.name }}<span class="text_red">*</span></label>
              <b-form-input
                :id="item.uuid"
                size="sm"
                v-model="item.value"
                :disabled="isDisabled"
                @keyup="calculateTotal(item.uuid)"
              />
            </div>
          </b-col>
          <b-col lg="6" md="6" sm="12" class="mb-3">
            <div role="group">
              <label class="label_input">Proveedor<span class="text_red">*</span></label>
              <v-select
                :options="suppliers"
                label="name"
                class="style-chooser"
                placeholder="Seleccione"
                v-model="item.supplier"
                :reduce="(option) => option.uuid"
                :disabled="isDisabled"
              >
                <div slot="no-options">Sin opciones</div>
              </v-select>
            </div>
          </b-col>
          <b-col lg="6" md="6" sm="12" class="mb-3">
            <div role="group">
              <label class="label_input">N° de factura</label>
              <b-form-input
                :id="`invoice_number-${item.uuid}`"
                size="sm"
                type="number"
                v-model="item.invoice_number"
                :disabled="isDisabled"
              />
            </div>
          </b-col>
          <b-col lg="6" md="6" sm="12" class="mb-3">
            <div role="group">
              <label class="label_input">Fecha</label>
              <b-form-input
                :id="`date-${item.uuid}`"
                size="sm"
                type="date"
                v-model="item.date"
                :disabled="isDisabled"
              />
            </div>
          </b-col>
          <b-col lg="12" md="12" sm="12" class="">
            <div role="group">
              <label class="label_input">Observaciones</label>
              <b-form-textarea
                :id="`textarea-${item.uuid}`"
                v-model="item.observations"
                placeholder="Observación..."
                rows="3"
                :disabled="isDisabled"
              ></b-form-textarea>
            </div>
          </b-col>
          <b-col lg="12" md="12" sm="12">
            <hr />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <hr />
    <b-row class="mb-4">
      <div class="pl-4">
        <div class="d-flex align-items-center">
          <div class="text-liquidation mr-1">Total gastos:</div>
          <div class="value-liquidation">
            {{ formatTotal(formData.total_costs) }}
          </div>
        </div>
        <div class="d-flex align-items-center">
          <div class="text-liquidation mr-1">Total a liquidar:</div>
          <div class="value-liquidation">{{ formatTotal(totalSales) }}</div>
        </div>
        <div class="d-flex align-items-center">
          <div class="text-liquidation mr-1">Utilidad:</div>
          <div
            class="value-liquidation"
            :class="{ 'text-danger': isUtilityNegative }"
          >
            {{ isUtilityNegative ? "-" : "" }}
            {{ formatUtility(formData.utility) }}
          </div>
        </div>
      </div>
    </b-row>
    <b-row class="footer-modal-customer" v-if="!isDisabled">
      <b-col cols="12" class="d-flex justify-content-end">
        <b-button
          type="submit"
          size="lg"
          class="btn btn-success w-width"
          :disabled="isBusy || $v.$invalid"
        >
          <b-spinner class="mr-2" v-if="isBusy" small />
          Guardar
        </b-button>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import {
  BCol,
  BRow,
  BButton,
  BForm,
  BSpinner,
  BFormInput,
  BFormTextarea,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { required } from "vuelidate/lib/validators";
import ActionCRUD from "@/mixins/ActionCRUD";
import { formatNumber, formatPrice } from "@/utils";

export default {
  inject: [
    "variableLiquidationRepository",
    "liquidationRepository",
    "supplierRepository",
  ],
  components: {
    BCol,
    BRow,
    BButton,
    BForm,
    BFormInput,
    BSpinner,
    vSelect,
    BFormTextarea,
  },
  mixins: [ActionCRUD],
  props: {
    record: {
      type: Object,
      default: null,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    totalSales: {
      type: Number,
      default: null,
    },
    travelUuid: {
      type: String,
      default: null,
    },
  },
  data() {
    const me = this;
    return {
      isBusy: false,
      formData: {
        total_costs: 0,
        variables_costs: [],
        total_sales: me.totalSales,
        utility: 0,
        travelUuid: me.travelUuid,
      },
      repository: "liquidationRepository",
      variables: [],
      suppliers: [],
      isUtilityNegative: false,
    };
  },
  validations: {
    formData: {
      total_costs: {
        required,
      },
      variables_costs: {
        $each: {
          supplier: {
            required,
          },
        },
      }
    },
  },
  methods: {
    async loadVariables() {
      const me = this;
      try {
        const { data } = await me.variableLiquidationRepository.getAll();
        data.forEach((el) => {
          me.variables.push({
            uuid: el.uuid,
            name: el.name,
            value: 0,
            supplier: null,
            date: "",
            invoice_number: "",
            observations: "",
          });
        });
      } catch (error) {
        const { status } = error.data;
        if (status == 419) {
          me.$bvModal.show("expired-token-model");
        } else if (status == 403) {
          me.$bvModal.show("session-finish-modal");
        }
      }
    },
    async loadSuppliers() {
      const me = this;
      try {
        const { data } = await me.supplierRepository.getAll();
        data.forEach((el) => {
          me.suppliers.push({
            uuid: el.uuid,
            name: el.name,
          });
        });
        me.suppliers.push({
          uuid: "9d637eb8-251e-4b83-a052-ea842b47b1e1",
          name: "Otro proveedor",
        });
      } catch (error) {
        const { status } = error.data;
        if (status == 419) {
          me.$bvModal.show("expired-token-model");
        } else if (status == 403) {
          me.$bvModal.show("session-finish-modal");
        }
      }
    },
    calculateTotal(uuid) {
      const me = this;
      me.formData.total_costs = 0;
      me.formData.variables_costs.forEach((item) => {
        if (item.uuid === uuid) {
          item.value = formatNumber(item.value);
        }
        me.formData.total_costs +=
          item.value > 0 ? Number(item.value?.split(".")?.join("")) : 0;
      });
      me.calculateUtility();
    },
    formatTotal(value) {
      return formatPrice(value + "");
    },
    formatUtility(value) {
      const me = this;
      me.isUtilityNegative =
        Math.sign(value) === 1 || Math.sign(value) === 0 ? false : true;

      if (me.isUtilityNegative) {
        return formatPrice(value + "");
      }

      return formatPrice(Math.abs(value) + "");
    },
    calculateUtility() {
      const me = this;
      me.formData.utility = me.formData.total_sales - me.formData.total_costs;
    },
    saveLiquidation() {
      const me = this;
      me.saveData();
    },
  },
  async mounted() {
    const me = this;
    await me.loadSuppliers();
    me.loadVariables();
    if (me.record) {
      me.formData = { ...me.formData, ...me.record };
      me.formData.total_sales = me.totalSales;

      me.formData.variables_costs = me.record?.variables_costs;
      delete me.formData.status;
      delete me.formData.createdAt;
      delete me.formData.travel;
    }
  },
};
</script>
<style>
hr {
  background-color: white;
}
.text-liquidation {
  color: white;
  font-size: 16px;
}

.value-liquidation {
  color: white;
  font-size: 18px;
  font-weight: 700;
}
</style>
